// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Confirmation } from './confirmation';
import { Customer } from './customer';
import { Dealer } from './dealer';
import { DeliveryOption } from './delivery-option';
import { OrderAchPayment } from './order-ach-payment';
import { OrderAttachment } from './order-attachment';
import { OrderLine } from './order-line';
import { OrderLineDetail } from './order-line-detail';
import { OrderStatus } from './order-status';
import { OrderType } from './order-type';
import { PricingTier } from './pricing-tier';
import { SalesRep } from './sales-rep';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Order extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static DeliveryOptions = {
        Genesis: 1,
        CPU: 2,
        UPS: 3,
        TBD: 4,
        DPU: 5,
    };

    static Statuses = {
        New: 1,
        InProcess: 2,
        Complete: 3,
        Paid: 4,
        Canceled: 5,
        WaitingOnConfirmation: 6,
    };

    static Types = {
        SalesOrder: 1,
        Warranty: 2,
        RetailPartsOrder: 3,
        Winter: 4,
        Quote: 5,
        InvoiceCredit: 6,
        Credit: 7,
    };

    get statusName() {
        return this.status && this.status.name;
    }

    get subTotal() {
        let subTotal = 0;
        if (!!this.orderLines) {
            this.orderLines.forEach((line) => {
                if (!line.deleted) {
                    if (!line.parentLineId || line.isOption) {
                        // do not calculate price for sub-lines which are components for the assembly
                        subTotal += line.quantity * (line.paidAch ? line.achLineAmount : line.price);
                    }
                }
            });
        }
        return Number(subTotal.toFixed(2));
    }

    get winterDownPayment() {
        return 0.1 * this.total;
    }
    get originalTotal() {
        let total = 0;
        if (!!this.orderLines) {
            this.orderLines.forEach((line) => {
                if (!line.deleted) total += line.quantity * line.originalPrice;
            });
        }
        return total;
    }

    get discountAmount() {
        return this.originalTotal - this.subTotal;
    }

    get achDiscountAmount() {
        let total = 0;
        if (!!this.orderLines) {
            this.orderLines.forEach((line) => {
                if (!line.deleted) {
                    total += line.quantity * line.achLineAmount;
                }
            });
        }
        return total;
    }

    get achDiscountAmountDisplay() {
        let total = 0;
        if (this.achPayments.length > 0) return this.achPayments[0].amount;
        else if (!!this.orderLines) {
            this.orderLines.forEach((line) => {
                if (!line.deleted) {
                    total += line.quantity * line.achLineAmount;
                }
            });
        }
        return total;
    }

    get invoiceNumberDisplay(): string {
        if (this.typeId === Order.Types.Warranty) return `W-${this.invoiceNumber}`;
        else return this.invoiceNumber.toString();
    }

    static getNextLineNumber(lines: any[]) {
        if (lines.length === 0) return 1;

        let lineNumber: any;
        lineNumber = _.maxBy(lines, 'lineNumber').lineNumber + 1;
        return lineNumber;
    }

    getNextLineNumber() {
        return Order.getNextLineNumber(this.orderLines);
    }
    get shippingAddressDisplay() {
        return `${!!this.shipToLocation ? this.shipToLocation + ' - ' : ''}${this.shipToAddress1}${this.shipToAddress2 ? ' ' + this.shipToAddress2 + ' ' : ''} ${
            this.shipToCity
        }, ${this.shipToState} ${this.shipToZip}  ${this.shipToCountry}`;
    }

    get allowFreightEntry() {
        let allow = false;
        if (!!this.deliveryOptionId) {
            if (this.deliveryOptionId === Order.DeliveryOptions.UPS) allow = true;
        }
        return allow;
    }

    // get freightDisplay() {
    //     let freight = 'TBD';
    //     if (!!this.deliveryOptionId) {
    //         if (this.deliveryOptionId === Order.DeliveryOptions.UPS) freight = this.freight.toString();
    //         else if (this.deliveryOptionId === Order.DeliveryOptions.CPU || this.deliveryOptionId === Order.DeliveryOptions.DPU) freight = '0.00';
    //     }
    //     return freight;
    // }

    get freightTotal() {
        let total = 0;
        if (!!this.orderLines) {
            this.orderLines.forEach((line) => {
                if (!line.deleted && line.part && line.part.isFreight) {
                    total += line.quantity * line.price;
                }
            });
        }
        return total;
    }

    get loadedMiles() {
        let loadedMiles = null;
        if (this.dealer && this.dealer.shipSameAsBilling && this.dealer.loadedMiles != null) {
            loadedMiles = this.dealer.loadedMiles;
        } else if (this.dealer && this.shipAddressId) {
            const shipAddress = this.dealer.shipAddresses.find((x) => x.id === this.shipAddressId);
            if (shipAddress && shipAddress.loadedMiles != null) {
                loadedMiles = shipAddress.loadedMiles;
            }
        }
        return loadedMiles;
    }

    get freightDisplay() {
        let freight = 'TBD';
        if (!!this.deliveryOptionId) {
            if (this.deliveryOptionId === Order.DeliveryOptions.UPS) freight = this.freight.toString();
            else if (this.deliveryOptionId === Order.DeliveryOptions.CPU || this.deliveryOptionId === Order.DeliveryOptions.DPU)
                freight = 'Selected Delivery Option does not require Freight';
            else if ((this.dealer && !!this.loadedMiles) || (this.dealer && this.loadedMiles === 0)) {
                if (this.loadedMiles >= 0 && this.loadedMiles <= 40) freight = '$45.00 ea.';
                else if (this.loadedMiles > 40 && this.loadedMiles <= 300) freight = '$125.00 ea.';
                else if (this.loadedMiles > 300 && this.loadedMiles <= 500) freight = '$125.00 ea.';
                else if (this.loadedMiles > 500) freight = 'Quoted Freight Required';
            }
        }
        return freight;
    }

    updateDisplayOrder() {
        _.orderBy(this.orderLines, 'lineNumber').forEach((line, index) => {
            if (line.lineNumber !== index + 1) line.lineNumber = index + 1;
        });
    }

    _salesBasedTierId: number = 1;
    getTierBySales(pricingTiers: PricingTier[]) {
        //check if the dealer has a Tier Override set
        // console.log(pricingTiers);
        let tier = null;
        if (this.currentYTDSales > 0 && this.dealerId !== Dealer.DealerOptions.Miscellaneous) {
            tier = _.find(pricingTiers, (x) => {
                return this.currentYTDSales >= x.minimumAmount && this.currentYTDSales < x.maximumAmount;
            });
        }
        this._salesBasedTierId = !!tier ? tier.id : 1;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  achTotal!: number;
  balance!: number;
  colorCode?: string;
  createDate?: Date;
  createdById?: number;
  createdTimestamp?: Date;
  currentYTDSales?: number;
  customerId?: number;
  dealerDeliveryOptionId?: number;
  dealerId?: number;
  deleted?: Date;
  deliverer?: string;
  deliveryOptionId?: number;
  deliveryOptionString?: string;
  discountName?: string;
  discountPercentage!: number;
  dueDate?: Date;
  freight!: number;
  invoiceNumber!: number;
  noPrePay!: boolean;
  note?: string;
  orderGuid?: string;
  orderType?: string;
  pONumber?: string;
  paymentMethod?: string;
  pricingTierId?: number;
  printPrePayPricing!: boolean;
  printPricing!: boolean;
  salesRepId?: number;
  shipAddressId?: number;
  shipToAddress1?: string;
  shipToAddress2?: string;
  shipToCity?: string;
  shipToContactName?: string;
  shipToCountry?: string;
  shipToEmail?: string;
  shipToLocation?: string;
  shipToPhone?: string;
  shipToState?: string;
  shipToZip?: string;
  shippingNote?: string;
  statusId!: number;
  tax!: number;
  total!: number;
  trackingNumber?: string;
  typeId?: number;
  uPSFreight!: number;
  vIN?: string;
  warrantyOrderLineDetailId?: number;
  achPayments!: OrderAchPayment[];
  confirmations!: Confirmation[];
  createdBy!: User;
  customer!: Customer;
  dealer!: Dealer;
  dealerDeliveryOption!: DeliveryOption;
  deliveryOption!: DeliveryOption;
  orderAttachments!: OrderAttachment[];
  orderLines!: OrderLine[];
  pricingTier!: PricingTier;
  salesRep!: SalesRep;
  status!: OrderStatus;
  type!: OrderType;
  warrantyOrderLineDetail!: OrderLineDetail;
}

